import React from 'react'
import { Message } from 'semantic-ui-react'
import '../App.css';

export default class Toastr extends React.Component{

  dismiss(){
    this.props.dismiss();
  }

  render(){
    let messageHeader = this.props.messageHeader
    let messageBody = this.props.messageBody
    let messageType = this.props.messageType

    return (
      <Message floating className={`toastr toastr-${messageType}`}>
        {
          !this.props.noDimiss &&
          <i className="close icon" onClick={ this.dismiss.bind(this) }></i>
        }
        <Message.Header>
          {messageHeader}
        </Message.Header>
        <p>
          {messageBody}
        </p>
      </Message>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/toastr.js